<template>
  <Admin style="background: #f2f2f2;">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl tw-min-h-80">
          <v-card-text v-if="!selectedCompany.isDemo && selectedCompanyProductList?.isTopserv">
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true">
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <div class="tw-mt-1 tw-mx-5 tw-font-bold tw-text-xl tw-text-black tw-tracking-wide tw-mb-4">จัดการสาขา</div>
            <v-row align="center" justify="center" class="tw-mx-2">
              <v-col cols="12" class="tw-pt-1">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                    <!--                  <tr class="header-row">
                                        <th class="header-text tw-text-center">รายการสาขา</th>
                                      </tr>-->
                    </thead>
                    <tbody>
                    <tr v-for="branch in branchList" :key="branch.branchCode" class="tw-cursor-pointer">
                      <td class="tw-text-">{{ `${branch.branchName} (${branch.endsWith})` }}</td>
                      <td class="text-right">
                        <v-btn icon color="black" class="button-edit" @click="selectedBranchCode = branch.branchCode">
                          <img src="/images/icons/edit_user.svg" alt="edit-user"
                               style="vertical-align: middle; max-width: 26px;"/>
                        </v-btn>
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-btn block class="button-add-user" @click="addBranchDialog = true">
                <v-icon left>mdi-plus-circle-outline</v-icon>
                เพิ่มสาขา
              </v-btn>
            </v-row>
            <v-dialog v-model="addBranchDialog"  transition="dialog-bottom-transition"
                      max-width="600">
              <v-card class="tw-py-6 tw-px-8">
                <p class="tw-font-bold">เพิ่มสาขา</p>
                <v-text-field v-model="addBranchData.branchName" label="ชื่อสาขา" outlined dense></v-text-field>
                <v-text-field v-model="addBranchData.branchCode" label="รหัสสาขา" outlined dense></v-text-field>
                <v-text-field v-model="addBranchData.endsWith" label="ตัวย่อภาษาอังกฤษ" outlined dense></v-text-field>
                <div class="tw-flex tw-justify-end tw-gap-2">
                  <!--     align right             -->
                  <v-btn color="error" @click="addBranchDialog = false" outlined :disabled="isAdding">ยกเลิก</v-btn>
                  <v-btn color="primary" @click="handleAddBranch" :disabled="!isAddable || isAdding" outlined>{{ isAdding ? "กำลังเพิ่ม" : "เพิ่ม" }}</v-btn>
                </div>

              </v-card>
            </v-dialog>
            <v-dialog v-model="updateBranchDialog"  transition="dialog-bottom-transition"
                      max-width="600">
              <v-card class="tw-py-6 tw-px-8">
                <p class="tw-font-bold">แก้ไขสาขา</p>
                <v-text-field v-model="updateBranchData.branchName" label="ชื่อสาขา" outlined dense></v-text-field>
                <v-text-field v-model="updateBranchData.branchCode" label="รหัสสาขา" readonly outlined dense></v-text-field>
                <v-text-field v-model="updateBranchData.endsWith" label="ตัวย่อภาษาอังกฤษ" outlined dense></v-text-field>
                <div class="tw-flex tw-justify-between">
                  <v-btn color="error" :disabled="isUpdating" shaped @click="handleDeleteBranch">{{ isUpdating ? "กำลังลบ" : "ลบ" }}</v-btn>
                  <div class="tw-flex tw-justify-end tw-gap-2">
                    <v-btn color="error" @click="updateBranchDialog = false" outlined>ยกเลิก</v-btn>
                    <v-btn color="primary" @click="handleUpdateBranch" outlined :disabled="!isUpdatable || isUpdating">{{ isUpdating ? "กำลังแก้ไข" : "แก้ไข" }}</v-btn>
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-card-text>
          <div v-else class="align-center justify-center" style="height: 200px; display: flex;">
            No Permission
          </div>
          <v-snackbar v-model="snackbarSuccess" color="success" top class="tw-text-center">
            {{ snackbarSuccessText }}
          </v-snackbar>
          <v-snackbar v-model="snackbarError" color="error" top class="tw-text-center">
            {{ snackbarErrorText }}
          </v-snackbar>
        </v-card>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from '../../components/admin/admin-main-template'
import fc from "@/firebaseConfig";
import {mapState} from "vuex";
import _ from "lodash";
export default {
  name: 'SettingsBranch',
  components: {
    Admin,
  },
  data: () => ({
    items: [
      {
        text: 'ตั้งค่า',
        disabled: false,
        to: {name: 'Company.Settings'},
      },
      {
        text: 'จัดการสาขา',
        disabled: true,
      },
    ],
    branchList: [],
    addBranchDialog: false,
    addBranchData: {
      branchName: "",
      branchCode: "",
      endsWith: "", // TODO: change later
    },
    selectedBranchCode: "",
    updateBranchDialog: false,
    updateBranchData: {
      branchName: "",
      branchCode: "",
      endsWith: "", // TODO: change later
    },
    isUpdating: false,
    snackbarSuccess: false,
    snackbarSuccessText: "บันทึกสำเร็จ",
    snackbarError: false,
    snackbarErrorText: "บันทึกไม่สำเร็จ",
    isAdding: false,
    unsubscribe: [],
  }),
  computed: {
    ...mapState({
      selectedCompany: state => state.companies.selectedCompany,
      selectedCompanyProductList: state => state.companies.selectedCompanyProductList,
    }),
    isAddable() {
      return this.addBranchData.branchName !== "" && this.addBranchData.branchCode !== "" && this.addBranchData.endsWith !== ""
    },
    isUpdatable() {
      const isNotBlank = this.updateBranchData.branchName !== "" && this.updateBranchData.branchCode !== "" && this.updateBranchData.endsWith !== "";
      return isNotBlank && !_.isEqual(this.updateBranchData, this.branchList.find(branch => branch.branchCode === this.selectedBranchCode));
    }
  },
  beforeDestroy() {
    this.unsubscribe.forEach((unsubscribe) => {
      unsubscribe();
    });
  },
  methods: {
    async fetchBranchList() {
      const companyId = this.$route.params.companyId;
      const snapshot = fc.companies.doc(companyId).collection("TopservInvoiceSettings").doc("TOPSERV").onSnapshot(
        async (doc) => {
          if (doc.exists) {
            const data = doc.data();
            this.branchList = data?.branches;
          }
        }
      );
      this.unsubscribe.push(snapshot);
    },
    async handleAddBranch() {
      this.isAdding = true;
      const companyId = this.$route.params.companyId;
      const docRef = fc.companies.doc(companyId).collection("TopservInvoiceSettings").doc("TOPSERV");
      const doc = (await docRef.get()).data();
      let newBranches = []
      if (doc?.branches?.length > 0) {
        const isBranchCodeExists = doc.branches?.some(branch => branch.branchCode === this.addBranchData.branchCode && branch.endsWith === this.addBranchData.endsWith);
        if (isBranchCodeExists) {
          this.snackbarErrorText = "รหัสสาขานี้มีอยู่แล้ว"
          this.snackbarError = true;
          this.isAdding = false;
          return;
        }
      }
      newBranches = [...doc.branches, this.addBranchData] 
        console.log('doc.branches: ', doc.branches);
        console.log('newBranches: ', newBranches);

        docRef.set({
          branches: newBranches
        }, {merge: true});

      this.snackbarSuccess = true;
      this.addBranchDialog = false;
      this.isAdding = false;
    },
    async handleUpdateBranch() {
      this.isUpdating = true;
      const companyId = this.$route.params.companyId;
      const docRef = fc.companies.doc(companyId).collection("TopservInvoiceSettings").doc("TOPSERV");
      const doc = (await docRef.get()).data();
      doc.branches = doc?.branches?.map(branch => {
        if (branch.branchCode === this.updateBranchData.branchCode) {
          return this.updateBranchData;
        }
        return branch;
      });
      await docRef.set(doc);
      this.snackbarSuccess = true;
      this.updateBranchDialog = false;
      this.isUpdating = false;
    },
    async handleDeleteBranch() {
      this.isUpdating = true;
      const companyId = this.$route.params.companyId;
      const docRef = fc.companies.doc(companyId).collection("TopservInvoiceSettings").doc("TOPSERV")
      const doc = (await docRef.get()).data();
      doc.branches = doc?.branches?.filter(branch => branch.branchCode !== this.updateBranchData.branchCode);
      docRef.set(doc);
      this.snackbarSuccess = true;
      this.updateBranchDialog = false;
      this.isUpdating = false;
    }
  },
  watch: {
    addBranchDialog() {
      this.addBranchData = {
        branchName: "",
        branchCode: "",
        endsWith: "",
      }
    },
    selectedBranchCode() {
      const selectedBranch = this.branchList.find(branch => branch.branchCode === this.selectedBranchCode);
      if (selectedBranch) {
        this.updateBranchData = {
          ...selectedBranch,
        }
        this.updateBranchDialog = true;
      }
    },
    updateBranchDialog(val) {
      if (!val) {
        this.updateBranchData = {
          branchName: "",
          branchCode: "",
          endsWith: "",
        }
        this.selectedBranchCode = "";
      }
    },
    selectedCompanyProductList() {
      if (this.selectedCompanyProductList?.isTopserv) {
        this.fetchBranchList();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.row-wrapper{
  padding-left: 20px;
}
.button-add {
  background-color: white !important;
  border-top: thin solid #6ec39b;
  border-bottom: thin solid #6ec39b;
  box-shadow: unset !important;
  border-radius: unset;
}
</style>
